var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.tag,{tag:"tag",class:[ 'section-title', { 'no-bg-color': _vm.noBgColor } ],style:(_vm.headStyle)},[_vm._v(_vm._s(_vm.title))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }